module.exports = "<div class=\"hNine\" data-slnm-ihg=\"doNotCancelButtonSID\">\n    <div class=\"do-not-cancel-button\" (click)=\"onButtonClick()\" [innerText]=\"messages['actions.cancel.abort.label']\"></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/stay-mgmt/app/components/do-not-cancel-button/do-not-cancel-button.component.html
// module id = ./src/main/webapp/stay-mgmt/app/components/do-not-cancel-button/do-not-cancel-button.component.html
// module chunks = 0